export function getScenarioId(scenarioId) {
    {
        if (scenarioId != undefined &&
            scenarioId.toLowerCase() == 'allotments') {
            return scenarioId;
        }
        return '';
    }
}
//# sourceMappingURL=getScenarioId.js.map